// extracted by mini-css-extract-plugin
export var actionButton = "_g8-t";
export var buttonContainer = "_g8-0";
export var buttonContainer2 = "_g8-1";
export var buttonSection = "_g8-2";
export var details = "_g8-3";
export var dropdownItem = "_g8-5";
export var dropdownItemsContainer = "_g8-4";
export var fileInput = "_g8-r";
export var headerButton = "_g8-6";
export var icon = "_g8-7";
export var input = "_g8-8";
export var macroListItem = "_g8-9";
export var mainContent = "_g8-a";
export var microText = "_g8-b";
export var modal = "_g8-w";
export var optionsButton = "_g8-c";
export var paperclip = "_g8-s";
export var pillContent = "_g8-d";
export var preview = "_g8-e";
export var preview2 = "_g8-f";
export var quillEditor = "_g8-q";
export var selectedMacro = "_g8-g";
export var sidebar = "_g8-h";
export var sidebarHeader = "_g8-j";
export var sidebarList = "_g8-i";
export var sidebarListItem = "_g8-k";
export var sidebarSearch = "_g8-l";
export var snoozeDurationWrapper = "_g8-v";
export var statusPillContainer = "_g8-m";
export var tagsContainer = "_g8-n";
export var unselectedMacro = "_g8-o";
export var variable = "_g8-u";
export var wrapper = "_g8-p";